<template>
	<div class="card mb-0 shadow">
		<div class="card-body">
			<div class="tab-content">
				<div class="animate__animated animate__fadeIn">
					<div class="row">
						<div class="col-12">
							<h4 class="font-weight-bold">Avaliação Final</h4>
						</div>
					</div>
					<div class="row">
						<form-calendar
							grid="3"
							label="Data da Avaliação"
							v-model="avaliacao.data_avaliacao"
						/>
						<form-input
							:disabled="true"
							grid="6"
							label="Técnico Responsável"
							v-model="medida.responsavel.name"
						/>
						<form-input
							:disabled="true"
							grid="3"
							label="Meses de Acompanhamento"
							v-model="prazo"
						/>
						<form-input
							:disabled="true"
							grid="6"
							label="Orientador Social Responsável"
							v-model="medida.orientador_social_responsavel_nome"
						/>
						<form-input
							:disabled="true"
							grid="6"
							label="local cumprimento da medida"
							v-model="medida.acomp_creas_unidade_nome"
						/>
						<form-select
							:itens="$root.arrays.metas_pia"
							v-model="avaliacao.metas_pia"
							label="As metas e objetivos estabelecidas no PIA foram alcançados?"
						/>
						<form-select
							:itens="$root.arrays.cumpriu_condicionalidade"
							v-model="avaliacao.cumpriu_condicionalidade"
							label="O adolescente cumpriu com as condicionalidades estabelecidas no Termo de Compromisso?"
						/>
						<form-select
							:itens="$root.arrays.medidas_avaliacao"
							v-model="avaliacao.disponibilidade_adolescente"
							label="Sobre a disponibilidade do adolescente para realizar as atividades propostas:"
						/>
						<form-select
							:itens="$root.arrays.medidas_avaliacao"
							v-model="avaliacao.participacao_planejamento"
							label="Participação no planejamento do seu cronograma de atividades:"
						/>
						<form-select
							:itens="$root.arrays.medidas_avaliacao"
							v-model="avaliacao.frequencia"
							label="Assiduidade e frequência com que comparece para cumprir a prestação de serviços:"
						/>
						<form-select
							:itens="$root.arrays.medidas_avaliacao"
							v-model="avaliacao.pontualidade"
							label="Pontualidade:"
						/>
						<form-select
							:itens="$root.arrays.medidas_avaliacao"
							v-model="avaliacao.sociabilidade"
							label="Sociabilidade com a equipe e no local de prestação da medida:"
						/>
						<form-select
							:itens="$root.arrays.medidas_avaliacao"
							v-model="avaliacao.participacao_cumprimento"
							label="A participação da família no processo de cumprimento da medida pelo adolescente:"
						/>
						<form-textarea-editor
							class="mt-3"
							v-model="avaliacao.observacoes"
							label="Registre, descritivamente, os principais resultados alcançados, bem como fatores que contribuíram ou dificultaram o alcance dos resultados estabelecidos no PIA:"
						/>
					</div>
					<div class="row px-2 d-flex justify-content-end">
						<button
							class="btn btn-success btn-submit"
							data-style="zoom-in"
							@click="submit"
							type="submit"
						>
							<i class="mdi mdi-content-save" />
							{{ $t("Salvar") }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["medida"],
	data() {
		return {
			avaliacao: {
				data_avaliacao: "",
				tecnico_responsavel: "",
				meses_acompanhamento: "",
				orientador_social: "",
				local_cumprimento: "",
				metas_pia: "",
				cumpriu_condicionalidade: "",
				disponibilidade_adolescente: "",
				participacao_planejamento: "",
				frequencia: "",
				pontualidade: "",
				sociabilidade: "",
				participacao_cumprimento: "",
				observacoes: "",
			},
			prazo: "",
		};
	},
	mounted() {
		if (this.medida.avaliacao) {
			this.prazo = this.getPrazo(this.medida.criado);
			this.avaliacao = this.medida.avaliacao;
		}
	},
	methods: {
		submit() {
			if (this.avaliacao.data_avaliacao) {
				this.avaliacao.data_avaliacao = moment(this.avaliacao.data_avaliacao).format(
					"YYYY-MM-DD"
				);
			}
			this.avaliacao.tecnico_responsavel = this.medida.user_id;
			this.avaliacao.meses_acompanhamento = this.getPrazo(this.medida.criado);
			this.avaliacao.orientador_social = this.medida.orientador_social;
			this.avaliacao.local_cumprimento = this.medida.acomp_creas_unidade_id;

			this.$emit("submit");
		},
		getPrazo(data) {
			if (data) {
				var data_final = moment(data);
				var data_atual = moment();
				var prazo = data_final.diff(data_atual, "months");
				return prazo + " mes(es)";
			}
		},
	},
};
</script>
